export enum SurveyStatsStatusEnum {
	NotSent = 'Not sent',
	Sent = 'Sent',
	Delivered = 'Delivered',
	Completed = 'Completed',
}
